import {
  OnexAssignmentsPort,
  ActiveOnexConfigPort,
  LoggingServicePort,
} from '../../ports'
import {
  ActiveOnexConfig,
  GlobalOnexConfig,
  OnexConfig,
  OnexId,
  STATUS_QUO,
} from '@onex/model'

/**
 *
 */
export class ActiveOnexConfigAdapter implements ActiveOnexConfigPort {
  constructor(
    private readonly logger: LoggingServicePort,
    private readonly onexAssignmentsPort: OnexAssignmentsPort,
    private readonly globalOnexConfig: GlobalOnexConfig
  ) {}

  /**
 *
 *
 */
  async activeOnexConfig(): Promise<OnexConfig> {
    const defaultConfig = this.getDefaultConfig()
    try {
      if (!this.globalOnexConfig.active) {
        return defaultConfig
      }

      return {
        ...defaultConfig,
        ...(await this.onexAssignmentsPort(
          this.getActiveOnexId(),
          this.getActiveOnexConfig(),
          defaultConfig
        )),
      }
    } catch (error) {
      this.logger.error(
        new Error(`Could not fetch active onex assignments`, { cause: error })
      )
      return defaultConfig
    }
  }

  private getDefaultConfig(): OnexConfig {
    return this.getActiveOnexConfig()[STATUS_QUO]
  }

  private getActiveOnexConfig(): ActiveOnexConfig {
    return this.globalOnexConfig.activeOnexConfig
  }

  private getActiveOnexId(): OnexId {
    return this.globalOnexConfig.id
  }
}
